import { Enum, EnumVal } from '../../../../core/interfaces/object-enum';


export enum SyncFailureTypes {
  TRANSIENT = 'TRANSIENT',
  PERMANENT = 'PERMANENT'
}

export class SyncFailureType extends EnumVal {
  constructor(
    public name: string,
    public value: SyncFailureTypes,
    public description?: string,
    public alertType?: 'error' | 'warning',
    public canRetry?: boolean
  ) {
    super(name);
  }
}

export class SyncFailureTypeEnum extends Enum {
  static TRANSIENT = new SyncFailureType(
    'Records on Hold',
    SyncFailureTypes.TRANSIENT,
    'These records were not loaded to the Target. They will be automatically retried in the next Activation run.',
    'warning',
    true
  );
  static PERMANENT = new SyncFailureType(
    'Records not Loaded',
    SyncFailureTypes.PERMANENT,
    'These records are not retried by Hevo. Fix the data in the Warehouse so that they are picked in the next Activation run.',
    'error',
    false
  );
}

export interface SyncFailureMetaData {
  recordsFailedCount: number;
  warehouseErrorQuery?: string;
}

export interface SyncRecordFailure {
  recordCount: number;
  phase: string;
  error?: string;
  sampleData?: string;
}
